import React from 'react'

const ProfileDetailsTab = () => {
    return (
        <div className="_profile_details_main_content">
            <div className="_profile_details_main_content_txt">
                <h2 className="_profile_details_main_content_title text-center">
                    Profile details
                </h2>
            </div>
            <div className="_profile_details_main_content_input_wrap">
                <div className="row align-content-center my-3">
                    <div className="col-xl-6 col-lg-4 col-md-12 col-sm-12">
                        <div className="_profile_details_main_attach_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Profile details
                            </p>
                            <button className="_profile_details_main_attach_btn">
                                <span className="_profile_details_main_attach_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.76 22h10.48c2.76 0 3.86-1.69 3.99-3.75l.52-8.26A3.753 3.753 0 0 0 18 6c-.61 0-1.17-.35-1.45-.89l-.72-1.45C15.37 2.75 14.17 2 13.15 2h-2.29c-1.03 0-2.23.75-2.69 1.66l-.72 1.45C7.17 5.65 6.61 6 6 6 3.83 6 2.11 7.83 2.25 9.99l.52 8.26C2.89 20.31 4 22 6.76 22ZM10.5 8h3" />
                                        <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 18c1.79 0 3.25-1.46 3.25-3.25S13.79 11.5 12 11.5s-3.25 1.46-3.25 3.25S10.21 18 12 18Z" />
                                    </svg>
                                </span>
                                <label htmlFor="file1">
                                    <input id='file1' type="file" className='_profile_details_main_attach_input' />
                                </label>
                            </button>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-4 col-md-12 col-sm-12 ms-auto">
                        <div className="_profile_details_main_attach_wrap _profile_details_main_banner_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Profile  Banner
                            </p>
                            <button className="_profile_details_main_attach_btn _profile_details_main_banner_btn">
                                <span className="_profile_details_main_attach_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.76 22h10.48c2.76 0 3.86-1.69 3.99-3.75l.52-8.26A3.753 3.753 0 0 0 18 6c-.61 0-1.17-.35-1.45-.89l-.72-1.45C15.37 2.75 14.17 2 13.15 2h-2.29c-1.03 0-2.23.75-2.69 1.66l-.72 1.45C7.17 5.65 6.61 6 6 6 3.83 6 2.11 7.83 2.25 9.99l.52 8.26C2.89 20.31 4 22 6.76 22ZM10.5 8h3" />
                                        <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 18c1.79 0 3.25-1.46 3.25-3.25S13.79 11.5 12 11.5s-3.25 1.46-3.25 3.25S10.21 18 12 18Z" />
                                    </svg>
                                </span>
                                <label htmlFor="file2">
                                    <input id='file2' type="file" className='_profile_details_main_attach_input' />
                                </label>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-5 col-lg-4 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Username
                            </p>
                            <input type="text" placeholder='Enter your username' className='_profile_details_main_input' />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-4 col-md-12 col-sm-12 ms-auto">
                        <div className="_profile_details_main_input_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Email Adresss
                            </p>
                            <input type="text" placeholder='Enter your Email' className='_profile_details_main_input' />
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Bio
                            </p>
                            <textarea placeholder='Enter your bio' class="_profile_details_main_input form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Social Connections
                            </p>
                            <p className="_profile_details_main_attach_txt2">
                                Help collectors verify your account by connecting social accounts
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 mb-2">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <button className="_profile_details_main_input_btn">
                                <span className="_profile_details_main_input_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
                                        <path fill="#fff" d="M15.35 4.198a3.42 3.42 0 0 0 1.499-1.886 6.827 6.827 0 0 1-2.165.827 3.409 3.409 0 0 0-5.809 3.11A9.678 9.678 0 0 1 1.85 2.685a3.407 3.407 0 0 0 1.055 4.551 3.395 3.395 0 0 1-1.544-.426v.043a3.41 3.41 0 0 0 2.734 3.343 3.414 3.414 0 0 1-1.54.058 3.412 3.412 0 0 0 3.185 2.367 6.84 6.84 0 0 1-5.047 1.412 9.649 9.649 0 0 0 5.226 1.532c6.27 0 9.699-5.195 9.699-9.7 0-.147-.003-.294-.01-.44a6.93 6.93 0 0 0 1.701-1.765 6.817 6.817 0 0 1-1.958.537Z" />
                                    </svg>
                                </span>
                                <span className="_profile_details_main_input_btn_txt">
                                    Connect on Twitter
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <button className="_profile_details_main_input_btn">
                                <span className="_profile_details_main_input_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
                                        <path fill="#fff" d="M8.963 2.66c2.062 0 2.287 0 3.112.038.75.038 1.163.15 1.425.263.338.112.638.337.9.562.263.263.45.563.563.9.112.263.225.675.262 1.425.038.825.038 1.05.038 3.113 0 2.062 0 2.287-.038 3.112-.037.75-.15 1.163-.262 1.425a2.554 2.554 0 0 1-1.463 1.463c-.262.112-.675.225-1.425.262-.825.038-1.05.038-3.112.038-2.063 0-2.288 0-3.113-.038-.75-.037-1.162-.15-1.425-.262-.337-.113-.637-.338-.9-.563a2.28 2.28 0 0 1-.562-.9c-.113-.262-.225-.675-.263-1.425-.037-.825-.037-1.05-.037-3.112 0-2.063 0-2.288.037-3.113.038-.75.15-1.162.263-1.425.112-.337.337-.637.562-.9a2.28 2.28 0 0 1 .9-.562c.263-.113.675-.225 1.425-.263.825-.037 1.088-.037 3.113-.037Zm0-1.387c-2.1 0-2.363 0-3.188.038-.825.037-1.387.15-1.875.375a3.804 3.804 0 0 0-1.312.862 4.058 4.058 0 0 0-.9 1.35c-.188.488-.338 1.05-.375 1.875-.038.825-.038 1.088-.038 3.188s0 2.362.038 3.187c.037.825.15 1.388.375 1.875.187.488.487.975.9 1.35.375.375.862.713 1.35.9.487.188 1.05.338 1.875.375.825.038 1.087.038 3.187.038 2.1 0 2.363 0 3.188-.038.825-.037 1.387-.15 1.875-.375a3.913 3.913 0 0 0 2.25-2.25c.187-.487.337-1.05.375-1.875.037-.825.037-1.087.037-3.187 0-2.1 0-2.363-.037-3.188-.038-.825-.15-1.387-.375-1.875a3.296 3.296 0 0 0-.9-1.35 4.058 4.058 0 0 0-1.35-.9c-.488-.187-1.05-.337-1.875-.375H8.963Z" />
                                        <path fill="#fff" d="M8.963 5.023A3.937 3.937 0 1 0 12.9 8.961c.038-2.175-1.725-3.938-3.937-3.938Zm0 6.525a2.553 2.553 0 0 1-2.55-2.55 2.553 2.553 0 0 1 2.55-2.55 2.553 2.553 0 0 1 2.55 2.55c.037 1.388-1.125 2.55-2.55 2.55Zm4.125-5.735a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874Z" />
                                    </svg>
                                </span>
                                <span className="_profile_details_main_input_btn_txt">
                                    Connect on instagram
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 my-2">
                        <div className="_profile_details_main_input_wrap">
                            <p className="_profile_details_main_attach_txt">
                                Link
                            </p>
                            <input type="text" placeholder='yoursite.io' className='_profile_details_main_input' />
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <div className="_profile_details_main_input_wrap">
                            <button className="_profile_details_main_input_btn">
                                <span className="_profile_details_main_input_btn_txt">
                                    Save
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileDetailsTab